var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 478,
    viewBox: "0 0 593 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.068 223.412L236.361 228.514M236.361 228.514L224.976 234.325M224.976 234.325L215.008 240.702M215.008 240.702L206.599 247.599M206.599 247.599L199.844 254.922M199.844 254.922L194.836 262.575M194.836 262.575L191.624 270.464M191.624 270.464L190.301 278.495M190.301 278.495L190.868 286.526M190.868 286.526L193.277 294.462M193.277 294.462L197.529 302.21M197.529 302.21L203.576 309.674M203.576 309.674L211.276 316.807M211.276 316.807L220.629 323.421M220.629 323.421L231.448 329.468M231.448 329.468L243.636 334.853M243.636 334.853L256.958 339.53M256.958 339.53L271.319 343.451M271.319 343.451L286.483 346.569M286.483 346.569L302.262 348.789M302.262 348.789L318.465 350.112M318.465 350.112L334.858 350.537",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.947 181.893L250.641 187.609M250.641 187.609L249.129 193.467M249.129 193.467L249.507 199.372M249.507 199.372L251.727 205.182M251.727 205.182L255.695 210.757M255.695 210.757L261.412 216.048M261.412 216.048L268.687 220.866M268.687 220.866L277.379 225.118M277.379 225.118L287.347 228.755M287.347 228.755L298.307 231.637M298.307 231.637L310.022 233.763M310.022 233.763L322.305 235.039M322.305 235.039L334.871 235.464",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.514 152.744L255.924 158.035M255.924 158.035L254.129 163.515M254.129 163.515V169.042M254.129 169.042L255.971 174.522M255.971 174.522L259.514 179.813M259.514 179.813L264.758 184.821M264.758 184.821L271.608 189.356M271.608 189.356L279.828 193.418M279.828 193.418L289.276 196.867M289.276 196.867L299.764 199.654M299.764 199.654L311.007 201.638M311.007 201.638L322.817 202.867M322.817 202.867L334.863 203.292",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.858 129.262H333.535",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.518 160.393L258.762 165.731M258.762 165.731L259.848 171.069M259.848 171.069L262.73 176.265M262.73 176.265L267.407 181.179M267.407 181.179L273.69 185.714M273.69 185.714L281.437 189.776M281.437 189.776L290.46 193.225M290.46 193.225L300.617 195.965M300.617 195.965L311.577 197.996M311.577 197.996L323.056 199.225M323.056 199.225L334.867 199.65",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.944 191.293L253.613 196.395M253.613 196.395L255.172 201.403M255.172 201.403L258.574 206.268M258.574 206.268L263.723 210.851M263.723 210.851L270.525 215.055M270.525 215.055L278.84 218.834M278.84 218.834L288.382 222M288.382 222L299.059 224.598M299.059 224.598L310.538 226.487M310.538 226.487L322.538 227.621M322.538 227.621L334.867 227.999",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.074 195.123V272.551",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.074 272.545L249.925 277.505M249.925 277.505L252.523 282.371M252.523 282.371L256.822 287.001M256.822 287.001L262.68 291.394M262.68 291.394L270.049 295.362M270.049 295.362L278.694 298.858M278.694 298.858L288.52 301.834M288.52 301.834L299.291 304.196M299.291 304.196L310.724 305.897M310.724 305.897L322.676 306.936M322.676 306.936L334.864 307.22",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.945 166.207V198.047",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M334.873 164.27L331.188 164.836M331.188 164.836L328.212 166.584M328.212 166.584L326.559 169.23M326.559 169.23V172.159M326.559 172.159L328.212 174.757M328.212 174.757L331.188 176.505M331.188 176.505L334.873 177.072",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.785 169.656L310.588 172.443M310.588 172.443L312.903 174.663M312.903 174.663L316.21 175.891M316.21 175.891H319.847M319.847 175.891L323.154 174.663M323.154 174.663L325.422 172.443M325.422 172.443L326.272 169.656M326.272 169.656L325.422 166.868M325.422 166.868L323.154 164.648M323.154 164.648L319.847 163.42M319.847 163.42H316.21M316.21 163.42L312.903 164.648M312.903 164.648L310.588 166.868M310.588 166.868L309.785 169.656",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M293.527 167.247L294.331 170.035M294.331 170.035L296.598 172.255M296.598 172.255L299.905 173.483M299.905 173.483H303.59M303.59 173.483L306.897 172.255M306.897 172.255L309.164 170.035M309.164 170.035L309.967 167.247M309.967 167.247L309.164 164.46M309.164 164.46L306.897 162.24M306.897 162.24L303.59 161.012M303.59 161.012H299.905M299.905 161.012L296.598 162.24M296.598 162.24L294.331 164.46M294.331 164.46L293.527 167.247",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.359 162.191L279.163 164.978M279.163 164.978L281.477 167.198M281.477 167.198L284.784 168.474M284.784 168.474H288.422M288.422 168.474L291.728 167.198M291.728 167.198L293.996 164.978M293.996 164.978L294.846 162.191M294.846 162.191L293.996 159.451M293.996 159.451L291.728 157.183M291.728 157.183L288.422 155.955M288.422 155.955H284.784M284.784 155.955L281.477 157.183M281.477 157.183L279.163 159.451M279.163 159.451L278.359 162.191",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M265.238 154.496L266.041 157.283M266.041 157.283L268.309 159.503M268.309 159.503L271.616 160.779M271.616 160.779H275.301M275.301 160.779L278.607 159.503M278.607 159.503L280.875 157.283M280.875 157.283L281.678 154.496M281.678 154.496L280.875 151.756M280.875 151.756L278.607 149.488M278.607 149.488L275.301 148.26M275.301 148.26H271.616M271.616 148.26L268.309 149.488M268.309 149.488L266.041 151.756M266.041 151.756L265.238 154.496",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.52 142.539L260.323 145.326M260.323 145.326L262.59 147.546M262.59 147.546L265.897 148.774M265.897 148.774H269.582M269.582 148.774L272.889 147.546M272.889 147.546L275.156 145.326M275.156 145.326L275.959 142.539M275.959 142.539L275.156 139.751M275.156 139.751L272.889 137.531M272.889 137.531L269.582 136.303M269.582 136.303H265.897M265.897 136.303L262.59 137.531M262.59 137.531L260.323 139.751M260.323 139.751L259.52 142.539",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.605 129.695L261.409 132.482M261.409 132.482L263.723 134.702M263.723 134.702L266.983 135.931M266.983 135.931H270.668M270.668 135.931L273.975 134.702M273.975 134.702L276.242 132.482M276.242 132.482L277.093 129.695M277.093 129.695L276.242 126.908M276.242 126.908L273.975 124.687M273.975 124.687L270.668 123.459M270.668 123.459H266.983M266.983 123.459L263.723 124.687M263.723 124.687L261.409 126.908M261.409 126.908L260.605 129.695",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M326.227 170.221V199.463",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M309.691 168.947V197.717",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M293.527 165.643V194.176",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M278.359 162.664V188.316",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M265.238 153.879V179.153",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M259.52 142.301V170.126",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260.605 129.457V139.33",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.661 95.7227L273.26 99.8799M273.26 99.8799L271.512 104.273M271.512 104.273V108.714M271.512 108.714L273.212 113.06M273.212 113.06L276.661 117.264M276.661 117.264L281.669 121.138M281.669 121.138L288.141 124.634M288.141 124.634L295.888 127.61M295.888 127.61L304.675 129.972M304.675 129.972L314.312 131.72M314.312 131.72L324.469 132.759M324.469 132.759L334.862 133.043",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.055 106.49V106.726M275.055 106.726V106.915M275.055 106.915L275.102 107.152M275.102 107.152V107.388M275.102 107.388L275.149 107.577M275.149 107.577V107.813M275.149 107.813L275.196 108.049M275.196 108.049L275.244 108.238M275.244 108.238L275.338 108.474M275.338 108.474L275.385 108.711M275.385 108.711L275.433 108.947M275.433 108.947L275.527 109.183M275.527 109.183L275.622 109.419M275.622 109.419L275.716 109.655M275.716 109.655L275.811 109.892M275.811 109.892L275.905 110.128M275.905 110.128L276.047 110.364M276.047 110.364L276.141 110.6M276.141 110.6L276.283 110.836M276.283 110.836L276.425 111.073M276.425 111.073L276.566 111.309M276.566 111.309L276.755 111.592M276.755 111.592L276.897 111.828M276.897 111.828L277.086 112.065M277.086 112.065L277.275 112.301M277.275 112.301L277.464 112.584M277.464 112.584L277.7 112.821M277.7 112.821L277.889 113.104M277.889 113.104L278.125 113.34M278.125 113.34L278.362 113.576M278.362 113.576L278.598 113.86M278.598 113.86L278.834 114.096M278.834 114.096L279.07 114.379M279.07 114.379L279.354 114.616M279.354 114.616L279.637 114.899M279.637 114.899L279.92 115.135M279.92 115.135L280.204 115.419M280.204 115.419L280.535 115.655M280.535 115.655L280.818 115.891M280.818 115.891L281.149 116.175M281.149 116.175L281.48 116.411M281.48 116.411L281.81 116.694M281.81 116.694L282.188 116.93M282.188 116.93L282.519 117.167M282.519 117.167L282.897 117.45M282.897 117.45L283.275 117.686M283.275 117.686L283.653 117.923M283.653 117.923L284.031 118.206M284.031 118.206L284.456 118.442M284.456 118.442L284.881 118.678M284.881 118.678L285.306 118.915M285.306 118.915L285.731 119.151M285.731 119.151L286.156 119.434M286.156 119.434L286.581 119.67M286.581 119.67L287.054 119.907M287.054 119.907L287.479 120.143M287.479 120.143L287.951 120.379M287.951 120.379L288.424 120.615M288.424 120.615L288.896 120.804M288.896 120.804L289.416 121.04M289.416 121.04L289.888 121.277M289.888 121.277L290.408 121.513M290.408 121.513L290.928 121.749M290.928 121.749L291.447 121.938M291.447 121.938L291.967 122.174M291.967 122.174L292.487 122.363M292.487 122.363L293.053 122.599M293.053 122.599L293.573 122.788M293.573 122.788L294.14 123.025M294.14 123.025L294.707 123.214M294.707 123.214L295.274 123.402M295.274 123.402L295.841 123.591M295.841 123.591L296.408 123.828M296.408 123.828L297.022 124.017M297.022 124.017L297.589 124.206M297.589 124.206L298.203 124.395M298.203 124.395L298.817 124.536M298.817 124.536L299.431 124.725M299.431 124.725L300.045 124.914M300.045 124.914L300.659 125.103M300.659 125.103L301.273 125.245M301.273 125.245L301.935 125.434M301.935 125.434L302.549 125.576M302.549 125.576L303.21 125.764M303.21 125.764L303.824 125.906M303.824 125.906L304.486 126.048M304.486 126.048L305.147 126.237M305.147 126.237L305.809 126.379M305.809 126.379L306.47 126.52M306.47 126.52L307.131 126.662M307.131 126.662L307.84 126.804M307.84 126.804L308.501 126.946M308.501 126.946L309.21 127.04M309.21 127.04L309.871 127.182M309.871 127.182L310.58 127.323M310.58 127.323L311.288 127.418M311.288 127.418L311.997 127.56M311.997 127.56L312.658 127.654M312.658 127.654L313.367 127.749M313.367 127.749L314.076 127.89M314.076 127.89L314.832 127.985M314.832 127.985L315.54 128.079M315.54 128.079L316.249 128.174M316.249 128.174L316.957 128.268M316.957 128.268L317.713 128.363M317.713 128.363L318.422 128.41M318.422 128.41L319.178 128.504M319.178 128.504L319.886 128.599M319.886 128.599L320.642 128.646M320.642 128.646L321.351 128.693M321.351 128.693L322.107 128.788M322.107 128.788L322.863 128.835M322.863 128.835L323.571 128.882M323.571 128.882L324.327 128.93M324.327 128.93L325.083 128.977M325.083 128.977L325.839 129.024M325.839 129.024L326.594 129.071M326.594 129.071L327.303 129.119M327.303 129.119L328.059 129.166M328.059 129.166H328.815M328.815 129.166L329.571 129.213M329.571 129.213H330.327M330.327 129.213H331.082M331.082 129.213L331.838 129.26M331.838 129.26H332.594M332.594 129.26H333.35M333.35 129.26H334.106M334.106 129.26H334.862",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M276.661 101.537L276.566 101.726M276.566 101.726L276.472 101.868M276.472 101.868L276.377 102.009M276.377 102.009L276.283 102.198M276.283 102.198L276.189 102.34M276.189 102.34L276.094 102.529M276.094 102.529L276 102.671M276 102.671L275.952 102.86M275.952 102.86L275.858 103.002M275.858 103.002L275.811 103.143M275.811 103.143L275.716 103.332M275.716 103.332L275.669 103.474M275.669 103.474L275.574 103.616M275.574 103.616L275.527 103.805M275.527 103.805L275.48 103.946M275.48 103.946L275.433 104.088M275.433 104.088L275.385 104.277M275.385 104.277L275.338 104.419M275.338 104.419L275.244 104.702M275.244 104.702L275.196 105.033M275.196 105.033L275.149 105.316M275.149 105.316L275.102 105.6M275.102 105.6L275.055 105.883M275.055 105.883V106.214M275.055 106.214V106.497",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M271.273 105.975V123.595",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M190.41 282.943V420.509",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.93 297.965V429.909",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200.559 306.277V437.04",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.52 312.652V443.557",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M213.496 318.512V450.833",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M224.328 329.473V455.511",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M238.168 336.273V462.123",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.578 343.553V469.969",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M282.75 349.689V474.736",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M318.809 354.607V477.481",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M318.992 242.549V299.002",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M304.156 239.199V299.762",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M289.504 236.883V291.824",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M279.871 233.387V289.839",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M272.324 229.086V286.767",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M265.754 226.725V282.563",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M260.793 223.467V280.675",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M257.434 219.49V276.935",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M255.035 217.793V273.868",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M252.949 214.914V268.438",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M334.857 103.42L334.007 100.963M334.007 100.963L331.598 98.8372M331.598 98.8372L327.913 97.3254M327.913 97.3254L323.472 96.6641M323.472 96.6641L318.843 96.9003M318.843 96.9003L314.733 97.9869M314.733 97.9869L311.615 99.8293M311.615 99.8293L309.914 102.191M309.914 102.191V104.695M309.914 104.695L311.615 107.01M311.615 107.01L314.733 108.852M314.733 108.852L318.843 109.986M318.843 109.986L323.472 110.222M323.472 110.222L327.913 109.514M327.913 109.514L331.598 108.002M331.598 108.002L334.007 105.876M334.007 105.876L334.857 103.42",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M311.053 98.4644L310.202 96.0078M310.202 96.0078L307.793 93.882M307.793 93.882L304.108 92.3704M304.108 92.3704L299.62 91.709M299.62 91.709L295.038 91.8979M295.038 91.8979L290.881 93.0317M290.881 93.0317L287.81 94.8741M287.81 94.8741L286.109 97.1889M286.109 97.1889V99.6926M286.109 99.6926L287.81 102.055M287.81 102.055L290.881 103.897M290.881 103.897L295.038 104.984M295.038 104.984L299.62 105.22M299.62 105.22L304.108 104.558M304.108 104.558L307.793 103.047M307.793 103.047L310.202 100.921M310.202 100.921L311.053 98.4644",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M301.787 85.9489L300.937 83.5869M300.937 83.5869L298.527 81.5555M298.527 81.5555L294.842 80.0911M294.842 80.0911L290.402 79.4297M290.402 79.4297L285.772 79.6659M285.772 79.6659L281.662 80.7052M281.662 80.7052L278.544 82.5003M278.544 82.5003L276.844 84.7679M276.844 84.7679V87.1772M276.844 87.1772L278.544 89.3975M278.544 89.3975L281.662 91.1927M281.662 91.1927L285.772 92.2792M285.772 92.2792L290.402 92.4681M290.402 92.4681L294.842 91.8068M294.842 91.8068L298.527 90.3896M298.527 90.3896L300.937 88.311M300.937 88.311L301.787 85.9489",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M301.845 72.5758L300.995 70.1192M300.995 70.1192L298.539 67.9934M298.539 67.9934L294.854 66.4817M294.854 66.4817L290.413 65.8203M290.413 65.8203L285.831 66.0565M285.831 66.0565L281.674 67.143M281.674 67.143L278.556 68.9854M278.556 68.9854L276.902 71.3475M276.902 71.3475V73.8513M276.902 73.8513L278.556 76.1661M278.556 76.1661L281.674 78.0085M281.674 78.0085L285.831 79.1423M285.831 79.1423L290.413 79.3785M290.413 79.3785L294.854 78.6698M294.854 78.6698L298.539 77.1582M298.539 77.1582L300.995 75.0323M300.995 75.0323L301.845 72.5758",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M303.125 54.25L298.637 54.5334M298.637 54.5334L294.621 55.6672M294.621 55.6672L291.645 57.5096M291.645 57.5096L290.039 59.8245M290.039 59.8245V62.2809M290.039 62.2809L291.645 64.5485M291.645 64.5485L294.621 66.3909M294.621 66.3909L298.637 67.5247M298.637 67.5247L303.125 67.8081",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M309.73 103.705V127.137",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M285.926 98.6016V119.293",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M276.66 85.6113V111.452",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M301.793 85.8047V91.8987",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M276.707 72.8125L276.66 85.8509",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M301.793 73.0996V85.8074",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M289.836 61.0039V65.7752",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M322.057 35.584L315.869 37.2374M315.869 37.2374L310.625 39.5995M310.625 39.5995L306.609 42.4339M306.609 42.4339L304.058 45.6463M304.058 45.6463L303.066 49.0949M303.066 49.0949L303.775 52.4962M303.775 52.4962L306.09 55.7558M306.09 55.7558L309.869 58.6847M309.869 58.6847L314.924 61.1413M314.924 61.1413L321.018 62.9364M321.018 62.9364L327.773 63.9757M327.773 63.9757L334.859 64.2591",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M322.054 37.9453L316.763 39.5988M316.763 39.5988L312.464 41.819M312.464 41.819L309.488 44.4173M309.488 44.4173L307.977 47.3463M307.977 47.3463L308.024 50.3224M308.024 50.3224L309.63 53.2041M309.63 53.2041L312.701 55.8023M312.701 55.8023L317.047 57.9754M317.047 57.9754L322.432 59.6288M322.432 59.6288L328.479 60.5736M328.479 60.5736L334.857 60.8099",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M303.125 48.6211V92.1299",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 2.28516L330.517 2.66309M330.517 2.66309L326.643 3.74961M326.643 3.74961L323.809 5.40307M323.809 5.40307L322.297 7.43439M322.297 7.43439V9.56028M322.297 9.56028L323.809 11.5916M323.809 11.5916L326.643 13.2451M326.643 13.2451L330.517 14.2844M330.517 14.2844L334.863 14.6622",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M322.055 8.4668V59.5341",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M324.289 66.8164V96.2947",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M319.27 64.7773V96.0508",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M315.395 62.8945V96.9079",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M311.52 61.7598V96.6707",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M307.883 59.582V91.5641",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M305.523 58.2637V91.3322",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M306.52 59.3047V92.137",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M254.832 179.908V200.694",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M255.586 182.363V202.157",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M256.398 183.691V203.438",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M308.086 205.42V226.159",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M294.375 202.588V223.563",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M283.562 199.986V220.536",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M276.09 196.682V217.704",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M274.059 195.307V216.801",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M271.328 193.748V215.479",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M268.82 191.857V214.202",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M267.398 190.824V213.169",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 189.494V211.839",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M264.242 189.219V211.233",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M261.789 187.041V209.291",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M260.422 185.859V208.11",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M322.684 207.828V227.622",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M327.742 137.484V167.104",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M312.238 134.697V165.12",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M302.125 133.184V160.819",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M294.523 130.166V160.495",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M292.309 129.309V157.559",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M287.953 127.188V155.91",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M286.258 126.67V155.818",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M284.504 125.342V156.001",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M283.047 124.641V156.434",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M280.867 121.9V151.709",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M279.41 120.766V150.102",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M277.75 120.1V149.058",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M276.383 119.012V127.09",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M275.574 116.133V126.006",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M420.7 223.412L433.36 228.514M433.36 228.514L444.745 234.325M444.745 234.325L454.713 240.702M454.713 240.702L463.169 247.599M463.169 247.599L469.925 254.922M469.925 254.922L474.932 262.575M474.932 262.575L478.097 270.464M478.097 270.464L479.42 278.495M479.42 278.495L478.901 286.526M478.901 286.526L476.444 294.462M476.444 294.462L472.192 302.21M472.192 302.21L466.193 309.674M466.193 309.674L458.445 316.807M458.445 316.807L449.092 323.421M449.092 323.421L438.274 329.468M438.274 329.468L426.133 334.853M426.133 334.853L412.763 339.53M412.763 339.53L398.45 343.451M398.45 343.451L383.285 346.569M383.285 346.569L367.459 348.789M367.459 348.789L351.256 350.112M351.256 350.112L334.863 350.537",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M415.834 181.893L419.141 187.609M419.141 187.609L420.605 193.467M420.605 193.467L420.227 199.372M420.227 199.372L418.054 205.182M418.054 205.182L414.039 210.757M414.039 210.757L408.323 216.048M408.323 216.048L401.048 220.866M401.048 220.866L392.355 225.118M392.355 225.118L382.435 228.755M382.435 228.755L371.475 231.637M371.475 231.637L359.712 233.763M359.712 233.763L347.429 235.039M347.429 235.039L334.863 235.464",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M410.212 152.744L413.803 158.035M413.803 158.035L415.598 163.515M415.598 163.515V169.042M415.598 169.042L413.803 174.522M413.803 174.522L410.212 179.813M410.212 179.813L404.969 184.821M404.969 184.821L398.166 189.356M398.166 189.356L389.899 193.418M389.899 193.418L380.451 196.867M380.451 196.867L369.963 199.654M369.963 199.654L358.72 201.638M358.72 201.638L346.91 202.867M346.91 202.867L334.863 203.292",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 129.262H336.186",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M410.212 160.393L410.968 165.731M410.968 165.731L409.882 171.069M409.882 171.069L407 176.265M407 176.265L402.37 181.179M402.37 181.179L396.087 185.714M396.087 185.714L388.34 189.776M388.34 189.776L379.27 193.225M379.27 193.225L369.16 195.965M369.16 195.965L358.2 197.996M358.2 197.996L346.673 199.225M346.673 199.225L334.863 199.65",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M415.834 191.293L416.118 196.395M416.118 196.395L414.559 201.403M414.559 201.403L411.157 206.268M411.157 206.268L406.008 210.851M406.008 210.851L399.205 215.055M399.205 215.055L390.938 218.834M390.938 218.834L381.348 222M381.348 222L370.719 224.598M370.719 224.598L359.24 226.487M359.24 226.487L347.193 227.621M347.193 227.621L334.863 227.999",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M420.707 195.123V272.551",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M420.7 272.545L419.802 277.505M419.802 277.505L417.204 282.371M417.204 282.371L412.905 287.001M412.905 287.001L407.047 291.394M407.047 291.394L399.678 295.362M399.678 295.362L391.033 298.858M391.033 298.858L381.207 301.834M381.207 301.834L370.483 304.196M370.483 304.196L359.003 305.897M359.003 305.897L347.051 306.936M347.051 306.936L334.863 307.22",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M415.836 166.207V198.047",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 164.27L338.548 164.836M338.548 164.836L341.524 166.584M341.524 166.584L343.225 169.23M343.225 169.23V172.159M343.225 172.159L341.524 174.757M341.524 174.757L338.548 176.505M338.548 176.505L334.863 177.072",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M359.959 169.656L359.156 172.443M359.156 172.443L356.889 174.663M356.889 174.663L353.582 175.891M353.582 175.891H349.897M349.897 175.891L346.59 174.663M346.59 174.663L344.323 172.443M344.323 172.443L343.52 169.656M343.52 169.656L344.323 166.868M344.323 166.868L346.59 164.648M346.59 164.648L349.897 163.42M349.897 163.42H353.582M353.582 163.42L356.889 164.648M356.889 164.648L359.156 166.868M359.156 166.868L359.959 169.656",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M376.245 167.247L375.395 170.035M375.395 170.035L373.127 172.255M373.127 172.255L369.82 173.483M369.82 173.483H366.135M366.135 173.483L362.876 172.255M362.876 172.255L360.561 170.035M360.561 170.035L359.758 167.247M359.758 167.247L360.561 164.46M360.561 164.46L362.876 162.24M362.876 162.24L366.135 161.012M366.135 161.012H369.82M369.82 161.012L373.127 162.24M373.127 162.24L375.395 164.46M375.395 164.46L376.245 167.247",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M391.366 162.191L390.562 164.978M390.562 164.978L388.295 167.198M388.295 167.198L384.988 168.474M384.988 168.474H381.303M381.303 168.474L377.996 167.198M377.996 167.198L375.729 164.978M375.729 164.978L374.926 162.191M374.926 162.191L375.729 159.451M375.729 159.451L377.996 157.183M377.996 157.183L381.303 155.955M381.303 155.955H384.988M384.988 155.955L388.295 157.183M388.295 157.183L390.562 159.451M390.562 159.451L391.366 162.191",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M404.553 154.496L403.75 157.283M403.75 157.283L401.435 159.503M401.435 159.503L398.129 160.779M398.129 160.779H394.491M394.491 160.779L391.184 159.503M391.184 159.503L388.869 157.283M388.869 157.283L388.066 154.496M388.066 154.496L388.869 151.756M388.869 151.756L391.184 149.488M391.184 149.488L394.491 148.26M394.491 148.26H398.129M398.129 148.26L401.435 149.488M401.435 149.488L403.75 151.756M403.75 151.756L404.553 154.496",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M410.205 142.539L409.402 145.326M409.402 145.326L407.135 147.546M407.135 147.546L403.828 148.774M403.828 148.774H400.143M400.143 148.774L396.836 147.546M396.836 147.546L394.569 145.326M394.569 145.326L393.766 142.539M393.766 142.539L394.569 139.751M394.569 139.751L396.836 137.531M396.836 137.531L400.143 136.303M400.143 136.303H403.828M403.828 136.303L407.135 137.531M407.135 137.531L409.402 139.751M409.402 139.751L410.205 142.539",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M409.135 129.695L408.332 132.482M408.332 132.482L406.064 134.702M406.064 134.702L402.757 135.931M402.757 135.931H399.073M399.073 135.931L395.766 134.702M395.766 134.702L393.498 132.482M393.498 132.482L392.695 129.695M392.695 129.695L393.498 126.908M393.498 126.908L395.766 124.687M395.766 124.687L399.073 123.459M399.073 123.459H402.757M402.757 123.459L406.064 124.687M406.064 124.687L408.332 126.908M408.332 126.908L409.135 129.695",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M343.52 170.221V199.463",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M360.051 168.947V197.717",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M376.199 165.643V194.176",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M391.367 162.664V188.316",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M404.508 153.879V179.153",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M410.207 142.301V170.126",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M409.121 129.457V139.33",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M393.064 95.7227L396.513 99.8799M396.513 99.8799L398.261 104.273M398.261 104.273V108.714M398.261 108.714L396.513 113.06M396.513 113.06L393.064 117.264M393.064 117.264L388.056 121.138M388.056 121.138L381.585 124.634M381.585 124.634L373.837 127.61M373.837 127.61L365.05 129.972M365.05 129.972L355.413 131.72M355.413 131.72L345.304 132.759M345.304 132.759L334.863 133.043",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M394.67 106.49V106.726M394.67 106.726V106.915M394.67 106.915V107.152M394.67 107.152L394.623 107.388M394.623 107.388V107.577M394.623 107.577L394.576 107.813M394.576 107.813L394.528 108.049M394.528 108.049L394.481 108.238M394.481 108.238L394.434 108.474M394.434 108.474L394.339 108.711M394.339 108.711L394.292 108.947M394.292 108.947L394.198 109.183M394.198 109.183L394.103 109.419M394.103 109.419L394.009 109.655M394.009 109.655L393.914 109.892M393.914 109.892L393.82 110.128M393.82 110.128L393.725 110.364M393.725 110.364L393.584 110.6M393.584 110.6L393.442 110.836M393.442 110.836L393.3 111.073M393.3 111.073L393.158 111.309M393.158 111.309L392.97 111.592M392.97 111.592L392.828 111.828M392.828 111.828L392.639 112.065M392.639 112.065L392.45 112.301M392.45 112.301L392.261 112.584M392.261 112.584L392.072 112.821M392.072 112.821L391.836 113.104M391.836 113.104L391.647 113.34M391.647 113.34L391.411 113.576M391.411 113.576L391.174 113.86M391.174 113.86L390.891 114.096M390.891 114.096L390.655 114.379M390.655 114.379L390.371 114.616M390.371 114.616L390.088 114.899M390.088 114.899L389.804 115.135M389.804 115.135L389.521 115.419M389.521 115.419L389.238 115.655M389.238 115.655L388.907 115.891M388.907 115.891L388.576 116.175M388.576 116.175L388.245 116.411M388.245 116.411L387.915 116.694M387.915 116.694L387.584 116.93M387.584 116.93L387.206 117.167M387.206 117.167L386.828 117.45M386.828 117.45L386.45 117.686M386.45 117.686L386.072 117.923M386.072 117.923L385.694 118.206M385.694 118.206L385.269 118.442M385.269 118.442L384.891 118.678M384.891 118.678L384.466 118.915M384.466 118.915L384.041 119.151M384.041 119.151L383.616 119.434M383.616 119.434L383.143 119.67M383.143 119.67L382.718 119.907M382.718 119.907L382.246 120.143M382.246 120.143L381.773 120.379M381.773 120.379L381.301 120.615M381.301 120.615L380.829 120.804M380.829 120.804L380.309 121.04M380.309 121.04L379.837 121.277M379.837 121.277L379.317 121.513M379.317 121.513L378.797 121.749M378.797 121.749L378.278 121.938M378.278 121.938L377.758 122.174M377.758 122.174L377.238 122.363M377.238 122.363L376.719 122.599M376.719 122.599L376.152 122.788M376.152 122.788L375.585 123.025M375.585 123.025L375.018 123.214M375.018 123.214L374.451 123.402M374.451 123.402L373.884 123.591M373.884 123.591L373.317 123.828M373.317 123.828L372.751 124.017M372.751 124.017L372.136 124.206M372.136 124.206L371.522 124.395M371.522 124.395L370.955 124.536M370.955 124.536L370.341 124.725M370.341 124.725L369.727 124.914M369.727 124.914L369.066 125.103M369.066 125.103L368.452 125.245M368.452 125.245L367.837 125.434M367.837 125.434L367.176 125.576M367.176 125.576L366.562 125.764M366.562 125.764L365.901 125.906M365.901 125.906L365.239 126.048M365.239 126.048L364.578 126.237M364.578 126.237L363.916 126.379M363.916 126.379L363.255 126.52M363.255 126.52L362.594 126.662M362.594 126.662L361.932 126.804M361.932 126.804L361.224 126.946M361.224 126.946L360.562 127.04M360.562 127.04L359.854 127.182M359.854 127.182L359.145 127.323M359.145 127.323L358.484 127.418M358.484 127.418L357.775 127.56M357.775 127.56L357.067 127.654M357.067 127.654L356.358 127.749M356.358 127.749L355.649 127.89M355.649 127.89L354.941 127.985M354.941 127.985L354.232 128.079M354.232 128.079L353.476 128.174M353.476 128.174L352.768 128.268M352.768 128.268L352.059 128.363M352.059 128.363L351.303 128.41M351.303 128.41L350.595 128.504M350.595 128.504L349.839 128.599M349.839 128.599L349.13 128.646M349.13 128.646L348.374 128.693M348.374 128.693L347.618 128.788M347.618 128.788L346.91 128.835M346.91 128.835L346.154 128.882M346.154 128.882L345.398 128.93M345.398 128.93L344.642 128.977M344.642 128.977L343.934 129.024M343.934 129.024L343.178 129.071M343.178 129.071L342.422 129.119M342.422 129.119L341.666 129.166M341.666 129.166H340.91M340.91 129.166L340.154 129.213M340.154 129.213H339.399M339.399 129.213H338.643M338.643 129.213L337.887 129.26M337.887 129.26H337.131M337.131 129.26H336.375M336.375 129.26H335.619M335.619 129.26H334.863",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M393.066 101.537L393.161 101.726M393.161 101.726L393.303 101.868M393.303 101.868L393.397 102.009M393.397 102.009L393.492 102.198M393.492 102.198L393.586 102.34M393.586 102.34L393.633 102.529M393.633 102.529L393.728 102.671M393.728 102.671L393.822 102.86M393.822 102.86L393.87 103.002M393.87 103.002L393.964 103.143M393.964 103.143L394.011 103.332M394.011 103.332L394.106 103.474M394.106 103.474L394.153 103.616M394.153 103.616L394.2 103.805M394.2 103.805L394.247 103.946M394.247 103.946L394.295 104.088M394.295 104.088L394.342 104.277M394.342 104.277L394.389 104.419M394.389 104.419L394.484 104.702M394.484 104.702L394.531 105.033M394.531 105.033L394.578 105.316M394.578 105.316L394.625 105.6M394.625 105.6L394.673 105.883M394.673 105.883V106.214M394.673 106.214V106.497",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M398.453 105.975V123.595",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M479.371 282.943V420.509",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M474.797 297.965V429.909",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M469.168 306.277V437.04",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M463.227 312.652V443.557",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M456.23 318.512V450.833",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M445.398 329.473V455.511",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M431.613 336.273V462.123",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M411.148 343.553V469.969",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M386.977 349.689V474.736",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M350.973 354.607V477.481",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M350.734 242.549V299.002",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M365.625 239.199V299.762",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M380.223 236.883V291.824",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M389.891 233.387V289.839",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M397.422 229.086V286.767",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M403.973 226.725V282.563",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M408.992 223.467V280.675",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M412.293 219.49V276.935",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M414.691 217.793V273.868",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M416.777 214.914V268.438",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 103.42L335.714 100.963M335.714 100.963L338.17 98.8372M338.17 98.8372L341.855 97.3254M341.855 97.3254L346.296 96.6641M346.296 96.6641L350.878 96.9003M350.878 96.9003L355.035 97.9869M355.035 97.9869L358.153 99.8293M358.153 99.8293L359.806 102.191M359.806 102.191V104.695M359.806 104.695L358.153 107.01M358.153 107.01L355.035 108.852M355.035 108.852L350.878 109.986M350.878 109.986L346.296 110.222M346.296 110.222L341.855 109.514M341.855 109.514L338.17 108.002M338.17 108.002L335.714 105.876M335.714 105.876L334.863 103.42",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M358.668 98.4644L359.518 96.0078M359.518 96.0078L361.975 93.882M361.975 93.882L365.66 92.3704M365.66 92.3704L370.1 91.709M370.1 91.709L374.683 91.8979M374.683 91.8979L378.84 93.0317M378.84 93.0317L381.958 94.8741M381.958 94.8741L383.611 97.1889M383.611 97.1889V99.6926M383.611 99.6926L381.958 102.055M381.958 102.055L378.84 103.897M378.84 103.897L374.683 104.984M374.683 104.984L370.1 105.22M370.1 105.22L365.66 104.558M365.66 104.558L361.975 103.047M361.975 103.047L359.518 100.921M359.518 100.921L358.668 98.4644",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M367.934 85.9489L368.784 83.5869M368.784 83.5869L371.193 81.5555M371.193 81.5555L374.925 80.0911M374.925 80.0911L379.366 79.4297M379.366 79.4297L383.948 79.6659M383.948 79.6659L388.106 80.7052M388.106 80.7052L391.176 82.5003M391.176 82.5003L392.877 84.7679M392.877 84.7679V87.1772M392.877 87.1772L391.176 89.3975M391.176 89.3975L388.106 91.1927M388.106 91.1927L383.948 92.2792M383.948 92.2792L379.366 92.4681M379.366 92.4681L374.925 91.8068M374.925 91.8068L371.193 90.3896M371.193 90.3896L368.784 88.311M368.784 88.311L367.934 85.9489",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M367.895 72.5758L368.745 70.1192M368.745 70.1192L371.201 67.9934M371.201 67.9934L374.886 66.4817M374.886 66.4817L379.327 65.8203M379.327 65.8203L383.956 66.0565M383.956 66.0565L388.066 67.143M388.066 67.143L391.184 68.9854M391.184 68.9854L392.838 71.3475M392.838 71.3475V73.8513M392.838 73.8513L391.184 76.1661M391.184 76.1661L388.066 78.0085M388.066 78.0085L383.956 79.1423M383.956 79.1423L379.327 79.3785M379.327 79.3785L374.886 78.6698M374.886 78.6698L371.201 77.1582M371.201 77.1582L368.745 75.0323M368.745 75.0323L367.895 72.5758",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M366.602 54.25L371.089 54.5334M371.089 54.5334L375.105 55.6672M375.105 55.6672L378.081 57.5096M378.081 57.5096L379.687 59.8245M379.687 59.8245V62.2809M379.687 62.2809L378.081 64.5485M378.081 64.5485L375.105 66.3909M375.105 66.3909L371.089 67.5247M371.089 67.5247L366.602 67.8081",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M359.996 103.705V127.137",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M383.855 98.6016V119.293",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M393.066 85.6113V111.452",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M367.934 85.8047V91.8987",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M393.066 72.8125V85.8509",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M367.934 73.0996V85.8074",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M379.926 61.0039V65.7752",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M347.666 35.584L353.854 37.2374M353.854 37.2374L359.145 39.5995M359.145 39.5995L363.161 42.4339M363.161 42.4339L365.712 45.6463M365.712 45.6463L366.656 49.0949M366.656 49.0949L365.948 52.4962M365.948 52.4962L363.68 55.7558M363.68 55.7558L359.901 58.6847M359.901 58.6847L354.799 61.1413M354.799 61.1413L348.752 62.9364M348.752 62.9364L341.949 63.9757M341.949 63.9757L334.863 64.2591",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M347.666 37.9453L353.004 39.5988M353.004 39.5988L357.256 41.819M357.256 41.819L360.279 44.4173M360.279 44.4173L361.791 47.3463M361.791 47.3463L361.743 50.3224M361.743 50.3224L360.137 53.2041M360.137 53.2041L357.019 55.8023M357.019 55.8023L352.673 57.9754M352.673 57.9754L347.335 59.6288M347.335 59.6288L341.241 60.5736M341.241 60.5736L334.863 60.8099",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M366.602 48.6211V92.1299",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 2.28516L339.257 2.66309M339.257 2.66309L343.083 3.74961M343.083 3.74961L345.965 5.40307M345.965 5.40307L347.477 7.43439M347.477 7.43439V9.56028M347.477 9.56028L345.965 11.5916M345.965 11.5916L343.083 13.2451M343.083 13.2451L339.257 14.2844M339.257 14.2844L334.863 14.6622",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M347.672 8.4668V59.5341",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M345.457 66.8164V96.2947",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M350.457 64.7773V96.0508",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M354.332 62.8945V96.9079",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M358.207 61.7598V96.6707",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M361.844 59.582V91.5641",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M364.203 58.2637V91.3322",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M363.262 59.3047V92.137",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M414.895 179.908V200.694",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M414.141 182.363V202.157",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M413.383 183.691V203.438",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M361.656 205.42V226.159",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M375.406 202.588V223.563",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M386.164 199.986V220.536",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M393.637 196.682V217.704",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M395.703 195.307V216.801",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M398.453 193.748V215.479",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M400.906 191.857V214.202",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M402.328 190.824V213.169",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M403.879 189.494V211.839",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M405.484 189.219V211.233",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M407.996 187.041V209.291",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M409.324 185.859V208.11",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M347.062 207.828V227.622",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M342.043 137.484V167.104",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M357.543 134.697V165.12",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M367.602 133.184V160.819",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M375.203 130.166V160.495",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M377.473 129.309V157.559",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M381.828 127.188V155.91",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M383.469 126.67V155.818",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M385.223 125.342V156.001",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M386.734 124.641V156.434",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M388.859 121.9V151.709",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M390.371 120.766V150.102",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M392.031 120.1V149.058",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M393.398 119.012V127.09",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M394.191 116.133V126.006",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M334.293 66.7148V100.161",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M334.863 103.428V129.268",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.36204
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M427.179 213.783L420.707 211.326L427.651 211.562L427.179 213.783Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M422.402 178.256L415.836 176.083L422.78 175.988L422.402 178.256Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M259.758 139.616L266.702 139.238L260.278 141.837L259.758 139.616Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M264.485 105.551L271.288 107.015L264.391 107.866L264.485 105.551Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M400.011 72.9512L393.066 72.8095L399.68 70.6836L400.011 72.9512Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M354.569 22.552L347.672 23.544L353.86 20.3789L354.569 22.552Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M2 329.094V320.543M2 320.543H7.29095M2 324.606H5.25963M9.32227 329.094V320.543M12.6292 329.094V320.543M12.6292 320.543H16.2667M16.2667 320.543L17.495 320.921M17.495 320.921L17.9201 321.346M17.9201 321.346L18.2981 322.149M18.2981 322.149V323M18.2981 323L17.9201 323.803M17.9201 323.803L17.495 324.181M17.495 324.181L16.2667 324.606M16.2667 324.606H12.6292M15.4637 324.606L18.2981 329.094M21.1798 329.094V320.543M21.1798 320.543H26.4707M21.1798 324.606H24.4394M21.1798 329.094H26.4707M28.9273 329.094V320.543M28.9273 320.543H32.6121M32.6121 320.543L33.8403 320.921M33.8403 320.921L34.2183 321.346M34.2183 321.346L34.6434 322.149M34.6434 322.149V323.377M34.6434 323.377L34.2183 324.181M34.2183 324.181L33.8403 324.606M33.8403 324.606L32.6121 325.031M32.6121 325.031H28.9273M37.525 329.094V320.543M37.525 320.543H41.1627M41.1627 320.543L42.3908 320.921M42.3908 320.921L42.816 321.346M42.816 321.346L43.194 322.149M43.194 322.149V323M43.194 323L42.816 323.803M42.816 323.803L42.3908 324.181M42.3908 324.181L41.1627 324.606M41.1627 324.606H37.525M40.3595 324.606L43.194 329.094M48.5322 320.543L47.6819 320.921M47.6819 320.921L46.8788 321.771M46.8788 321.771L46.5009 322.574M46.5009 322.574L46.0756 323.803M46.0756 323.803V325.834M46.0756 325.834L46.5009 327.062M46.5009 327.062L46.8788 327.865M46.8788 327.865L47.6819 328.716M47.6819 328.716L48.5322 329.094M48.5322 329.094H50.1384M50.1384 329.094L50.9887 328.716M50.9887 328.716L51.7919 327.865M51.7919 327.865L52.1697 327.062M52.1697 327.062L52.5949 325.834M52.5949 325.834V323.803M52.5949 323.803L52.1697 322.574M52.1697 322.574L51.7919 321.771M51.7919 321.771L50.9887 320.921M50.9887 320.921L50.1384 320.543M50.1384 320.543H48.5322M57.508 320.543L56.7048 320.921M56.7048 320.921L55.8545 321.771M55.8545 321.771L55.4766 322.574M55.4766 322.574L55.0515 323.803M55.0515 323.803V325.834M55.0515 325.834L55.4766 327.062M55.4766 327.062L55.8545 327.865M55.8545 327.865L56.7048 328.716M56.7048 328.716L57.508 329.094M57.508 329.094H59.1141M59.1141 329.094L59.9644 328.716M59.9644 328.716L60.7676 327.865M60.7676 327.865L61.1927 327.062M61.1927 327.062L61.5706 325.834M61.5706 325.834V323.803M61.5706 323.803L61.1927 322.574M61.1927 322.574L60.7676 321.771M60.7676 321.771L59.9644 320.921M59.9644 320.921L59.1141 320.543M59.1141 320.543H57.508M64.0272 329.094V320.543M64.0272 320.543H69.3182M64.0272 324.606H67.2869M84.8604 321.771L84.01 320.921M84.01 320.921L82.7818 320.543M82.7818 320.543H81.1757M81.1757 320.543L79.9474 320.921M79.9474 320.921L79.1442 321.771M79.1442 321.771V322.574M79.1442 322.574L79.5222 323.377M79.5222 323.377L79.9474 323.803M79.9474 323.803L80.7505 324.181M80.7505 324.181L83.207 325.031M83.207 325.031L84.01 325.409M84.01 325.409L84.4353 325.834M84.4353 325.834L84.8604 326.637M84.8604 326.637V327.865M84.8604 327.865L84.01 328.716M84.01 328.716L82.7818 329.094M82.7818 329.094H81.1757M81.1757 329.094L79.9474 328.716M79.9474 328.716L79.1442 327.865M87.2696 329.094V320.543M92.9859 320.543V329.094M87.2696 324.606H92.9859M96.2455 329.094V320.543M96.2455 320.543H101.584M96.2455 324.606H99.5523M96.2455 329.094H101.584M104.04 329.094L107.3 320.543M107.3 320.543L110.559 329.094M105.268 326.259H109.331M115.85 320.543V329.094M113.016 320.543H118.732M120.338 329.094V320.543M126.054 320.543V329.094M120.338 324.606H126.054",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M184.405 339.531L190.404 343.027L183.602 341.657L184.405 339.531Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M183.98 340.573L143.212 324.889M143.212 324.889H129.512",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M504.075 220.443L503.272 219.64M503.272 219.64L502.044 219.215M502.044 219.215H500.391M500.391 219.215L499.162 219.64M499.162 219.64L498.359 220.443M498.359 220.443V221.246M498.359 221.246L498.737 222.049M498.737 222.049L499.162 222.474M499.162 222.474L499.966 222.9M499.966 222.9L502.422 223.703M502.422 223.703L503.272 224.128M503.272 224.128L503.65 224.506M503.65 224.506L504.075 225.356M504.075 225.356V226.584M504.075 226.584L503.272 227.388M503.272 227.388L502.044 227.765M502.044 227.765H500.391M500.391 227.765L499.162 227.388M499.162 227.388L498.359 226.584M509.366 219.215V227.765M506.532 219.215H512.248M513.854 227.765V219.215M513.854 219.215H519.145M513.854 223.278H517.114M513.854 227.765H519.145M521.602 227.765V219.215M521.602 219.215H526.94M521.602 223.278H524.861M521.602 227.765H526.94M529.349 219.215V227.765M529.349 227.765H534.262M549.757 220.443L548.954 219.64M548.954 219.64L547.726 219.215M547.726 219.215H546.12M546.12 219.215L544.892 219.64M544.892 219.64L544.041 220.443M544.041 220.443V221.246M544.041 221.246L544.466 222.049M544.466 222.049L544.892 222.474M544.892 222.474L545.695 222.9M545.695 222.9L548.151 223.703M548.151 223.703L548.954 224.128M548.954 224.128L549.379 224.506M549.379 224.506L549.757 225.356M549.757 225.356V226.584M549.757 226.584L548.954 227.388M548.954 227.388L547.726 227.765M547.726 227.765H546.12M546.12 227.765L544.892 227.388M544.892 227.388L544.041 226.584M552.214 227.765V219.215M557.93 219.215V227.765M552.214 223.278H557.93M561.19 227.765V219.215M561.19 219.215H566.481M561.19 223.278H564.449M561.19 227.765H566.481M568.937 227.765L572.197 219.215M572.197 219.215L575.504 227.765M570.165 224.931H574.275M580.795 219.215V227.765M577.913 219.215H583.629M585.282 227.765V219.215M590.999 219.215V227.765M585.282 223.278H590.999",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M427.406 212.646L481.214 223.559M481.214 223.559H494.913",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M470.07 185.247V178.35M474.653 178.35L470.07 182.932M471.724 181.326L474.653 185.247M476.92 185.247V178.35M476.92 178.35H481.172M476.92 181.656H479.566M476.92 185.247H481.172M483.156 178.35L485.754 185.247M485.754 185.247L488.353 178.35M489.675 178.35V185.247M489.675 185.247H493.596M497.187 178.35L496.525 178.68M496.525 178.68L495.864 179.342M495.864 179.342L495.533 180.003M495.533 180.003L495.202 180.995M495.202 180.995V182.601M495.202 182.601L495.533 183.593M495.533 183.593L495.864 184.255M495.864 184.255L496.525 184.916M496.525 184.916L497.187 185.247M497.187 185.247H498.509M498.509 185.247L499.124 184.916M499.124 184.916L499.785 184.255M499.785 184.255L500.116 183.593M500.116 183.593L500.446 182.601M500.446 182.601V180.995M500.446 180.995L500.116 180.003M500.116 180.003L499.785 179.342M499.785 179.342L499.124 178.68M499.124 178.68L498.509 178.35M498.509 178.35H497.187M502.383 185.247V178.35M502.383 178.35H505.359M505.359 178.35L506.304 178.68M506.304 178.68L506.635 179.011M506.635 179.011L506.965 179.672M506.965 179.672V180.334M506.965 180.334L506.635 180.995M506.635 180.995L506.304 181.326M506.304 181.326L505.359 181.656M505.359 181.656H502.383M504.698 181.656L506.965 185.247",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M422.59 177.123L452.919 181.847M452.919 181.847H466.665",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M119.535 152.65L118.874 151.989M118.874 151.989L117.882 151.658M117.882 151.658H116.559M116.559 151.658L115.614 151.989M115.614 151.989L114.953 152.65M114.953 152.65V153.312M114.953 153.312L115.284 153.973M115.284 153.973L115.614 154.304M115.614 154.304L116.276 154.634M116.276 154.634L118.213 155.296M118.213 155.296L118.874 155.579M118.874 155.579L119.205 155.91M119.205 155.91L119.535 156.571M119.535 156.571V157.563M119.535 157.563L118.874 158.225M118.874 158.225L117.882 158.555M117.882 158.555H116.559M116.559 158.555L115.614 158.225M115.614 158.225L114.953 157.563M123.787 151.658V158.555M121.472 151.658H126.055M127.377 158.555V151.658M127.377 151.658H131.582M127.377 154.965H129.976M127.377 158.555H131.582M133.566 158.555V151.658M133.566 151.658H137.818M133.566 154.965H136.164M133.566 158.555H137.818M139.755 151.658V158.555M139.755 158.555H143.675M151.517 151.658L153.124 158.555M153.124 158.555L154.777 151.658M154.777 151.658L156.431 158.555M156.431 158.555L158.037 151.658M159.359 158.555V151.658M161.958 158.555V151.658M161.958 151.658H164.887M164.887 151.658L165.879 151.989M165.879 151.989L166.209 152.32M166.209 152.32L166.54 152.981M166.54 152.981V153.642M166.54 153.642L166.209 154.304M166.209 154.304L165.879 154.634M165.879 154.634L164.887 154.965M164.887 154.965H161.958M164.225 154.965L166.54 158.555M168.808 158.555V151.658M168.808 151.658H173.059M168.808 154.965H171.453M168.808 158.555H173.059M179.579 152.65L178.917 151.989M178.917 151.989L177.972 151.658M177.972 151.658H176.65M176.65 151.658L175.658 151.989M175.658 151.989L175.043 152.65M175.043 152.65V153.312M175.043 153.312L175.327 153.973M175.327 153.973L175.658 154.304M175.658 154.304L176.319 154.634M176.319 154.634L178.303 155.296M178.303 155.296L178.917 155.579M178.917 155.579L179.248 155.91M179.248 155.91L179.579 156.571M179.579 156.571V157.563M179.579 157.563L178.917 158.225M178.917 158.225L177.972 158.555M177.972 158.555H176.65M176.65 158.555L175.658 158.225M175.658 158.225L175.043 157.563",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M259.983 140.742L196.727 155.151M196.727 155.151H183.027",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1484 107.723V100.873M96.1484 100.873H100.4M96.1484 104.133H98.7939M102.054 107.723V100.873M104.652 107.723V100.873M104.652 100.873H107.581M107.581 100.873L108.573 101.204M108.573 101.204L108.904 101.534M108.904 101.534L109.234 102.196M109.234 102.196V102.857M109.234 102.857L108.904 103.519M108.904 103.519L108.573 103.849M108.573 103.849L107.581 104.133M107.581 104.133H104.652M106.967 104.133L109.234 107.723M111.502 107.723V100.873M111.502 100.873H115.753M111.502 104.133H114.147M111.502 107.723H115.753M117.738 107.723V100.873M117.738 100.873H120.666M120.666 100.873L121.658 101.204M121.658 101.204L121.942 101.534M121.942 101.534L122.273 102.196M122.273 102.196V103.188M122.273 103.188L121.942 103.849M121.942 103.849L121.658 104.133M121.658 104.133L120.666 104.463M120.666 104.463H117.738M124.588 107.723V100.873M124.588 100.873H127.516M127.516 100.873L128.508 101.204M128.508 101.204L128.839 101.534M128.839 101.534L129.123 102.196M129.123 102.196V102.857M129.123 102.857L128.839 103.519M128.839 103.519L128.508 103.849M128.508 103.849L127.516 104.133M127.516 104.133H124.588M126.855 104.133L129.123 107.723M133.374 100.873L132.713 101.204M132.713 101.204L132.099 101.865M132.099 101.865L131.768 102.527M131.768 102.527L131.437 103.519M131.437 103.519V105.125M131.437 105.125L131.768 106.117M131.768 106.117L132.099 106.778M132.099 106.778L132.713 107.44M132.713 107.44L133.374 107.723M133.374 107.723H134.697M134.697 107.723L135.358 107.44M135.358 107.44L136.02 106.778M136.02 106.778L136.35 106.117M136.35 106.117L136.634 105.125M136.634 105.125V103.519M136.634 103.519L136.35 102.527M136.35 102.527L136.02 101.865M136.02 101.865L135.358 101.204M135.358 101.204L134.697 100.873M134.697 100.873H133.374M140.555 100.873L139.941 101.204M139.941 101.204L139.279 101.865M139.279 101.865L138.949 102.527M138.949 102.527L138.618 103.519M138.618 103.519V105.125M138.618 105.125L138.949 106.117M138.949 106.117L139.279 106.778M139.279 106.778L139.941 107.44M139.941 107.44L140.555 107.723M140.555 107.723H141.878M141.878 107.723L142.539 107.44M142.539 107.44L143.2 106.778M143.2 106.778L143.531 106.117M143.531 106.117L143.814 105.125M143.814 105.125V103.519M143.814 103.519L143.531 102.527M143.531 102.527L143.2 101.865M143.2 101.865L142.539 101.204M142.539 101.204L141.878 100.873M141.878 100.873H140.555M145.799 107.723V100.873M145.799 100.873H150.05M145.799 104.133H148.397M162.427 101.865L161.813 101.204M161.813 101.204L160.821 100.873M160.821 100.873H159.498M159.498 100.873L158.506 101.204M158.506 101.204L157.892 101.865M157.892 101.865V102.527M157.892 102.527L158.223 103.188M158.223 103.188L158.506 103.519M158.506 103.519L159.168 103.849M159.168 103.849L161.152 104.463M161.152 104.463L161.813 104.794M161.813 104.794L162.097 105.125M162.097 105.125L162.427 105.786M162.427 105.786V106.778M162.427 106.778L161.813 107.44M161.813 107.44L160.821 107.723M160.821 107.723H159.498M159.498 107.723L158.506 107.44M158.506 107.44L157.892 106.778M164.411 107.723V100.873M168.994 100.873V107.723M164.411 104.133H168.994M171.592 107.723V100.873M171.592 100.873H175.844M171.592 104.133H174.19M171.592 107.723H175.844M177.781 107.723L180.379 100.873M180.379 100.873L183.024 107.723M178.773 105.455H182.032M187.276 100.873V107.723M184.961 100.873H189.544M190.866 107.723V100.873M195.401 100.873V107.723M190.866 104.133H195.401",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M264.433 106.686L212.563 104.371M212.563 104.371H198.863",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M449.183 63.791L448.569 64.1217M448.569 64.1217L447.907 64.7358M447.907 64.7358L447.577 65.3972M447.577 65.3972L447.246 66.3893M447.246 66.3893V68.0427M447.246 68.0427L447.577 68.9875M447.577 68.9875L447.907 69.6489M447.907 69.6489L448.569 70.3103M448.569 70.3103L449.183 70.6409M449.183 70.6409H450.506M450.506 70.6409L451.167 70.3103M451.167 70.3103L451.828 69.6489M451.828 69.6489L452.159 68.9875M452.159 68.9875L452.49 68.0427M452.49 68.0427V66.3893M452.49 66.3893L452.159 65.3972M452.159 65.3972L451.828 64.7358M451.828 64.7358L451.167 64.1217M451.167 64.1217L450.506 63.791M450.506 63.791H449.183M454.427 70.6409V63.791M454.427 63.791H457.356M457.356 63.791L458.348 64.1217M458.348 64.1217L458.678 64.4052M458.678 64.4052L459.009 65.0665M459.009 65.0665V66.0586M459.009 66.0586L458.678 66.7199M458.678 66.7199L458.348 67.0506M458.348 67.0506L457.356 67.3813M457.356 67.3813H454.427M463.591 63.791V70.6409M461.277 63.791H465.859M467.182 70.6409V63.791M474.693 65.3972L474.362 64.7358M474.362 64.7358L473.701 64.1217M473.701 64.1217L473.04 63.791M473.04 63.791H471.717M471.717 63.791L471.056 64.1217M471.056 64.1217L470.441 64.7358M470.441 64.7358L470.111 65.3972M470.111 65.3972L469.78 66.3893M469.78 66.3893V68.0427M469.78 68.0427L470.111 68.9875M470.111 68.9875L470.441 69.6489M470.441 69.6489L471.056 70.3103M471.056 70.3103L471.717 70.6409M471.717 70.6409H473.04M473.04 70.6409L473.701 70.3103M473.701 70.3103L474.362 69.6489M474.362 69.6489L474.693 68.9875M476.63 70.6409L479.228 63.791M479.228 63.791L481.874 70.6409M477.622 68.3261H480.882M483.81 63.791V70.6409M483.81 70.6409H487.732M495.574 70.6409V63.791M495.574 63.791H499.825M495.574 67.0506H498.172M501.431 70.6409V63.791M504.03 70.6409V63.791M504.03 63.791H507.006M507.006 63.791L507.951 64.1217M507.951 64.1217L508.281 64.4052M508.281 64.4052L508.612 65.0665M508.612 65.0665V65.7279M508.612 65.7279L508.281 66.3893M508.281 66.3893L507.951 66.7199M507.951 66.7199L507.006 67.0506M504.03 67.0506H507.006M507.006 67.0506L507.951 67.3813M507.951 67.3813L508.281 67.712M508.281 67.712L508.612 68.3261M508.612 68.3261V69.3182M508.612 69.3182L508.281 69.9796M508.281 69.9796L507.951 70.3103M507.951 70.3103L507.006 70.6409M507.006 70.6409H504.03M510.927 70.6409V63.791M510.927 63.791H515.131M510.927 67.0506H513.525M510.927 70.6409H515.131M517.115 70.6409V63.791M517.115 63.791H520.044M520.044 63.791L521.036 64.1217M521.036 64.1217L521.367 64.4052M521.367 64.4052L521.698 65.0665M521.698 65.0665V65.7279M521.698 65.7279L521.367 66.3893M521.367 66.3893L521.036 66.7199M521.036 66.7199L520.044 67.0506M520.044 67.0506H517.115M519.383 67.0506L521.698 70.6409M528.548 64.7358L527.886 64.1217M527.886 64.1217L526.894 63.791M526.894 63.791H525.619M525.619 63.791L524.627 64.1217M524.627 64.1217L523.965 64.7358M523.965 64.7358V65.3972M523.965 65.3972L524.296 66.0586M524.296 66.0586L524.627 66.3893M524.627 66.3893L525.288 66.7199M525.288 66.7199L527.225 67.3813M527.225 67.3813L527.886 67.712M527.886 67.712L528.217 68.0427M528.217 68.0427L528.548 68.6568M528.548 68.6568V69.6489M528.548 69.6489L527.886 70.3103M527.886 70.3103L526.894 70.6409M526.894 70.6409H525.619M525.619 70.6409L524.627 70.3103M524.627 70.3103L523.965 69.6489",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M399.82 71.8246L430.102 67.2422M430.102 67.2422H443.802",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M426.756 3.65346L426.426 2.99209M426.426 2.99209L425.812 2.33072M425.812 2.33072L425.15 2M425.15 2H423.828M423.828 2L423.166 2.33072M423.166 2.33072L422.505 2.99209M422.505 2.99209L422.221 3.65346M422.221 3.65346L421.891 4.59826M421.891 4.59826V6.25165M421.891 6.25165L422.221 7.24373M422.221 7.24373L422.505 7.9051M422.505 7.9051L423.166 8.51926M423.166 8.51926L423.828 8.84991M423.828 8.84991H425.15M425.15 8.84991L425.812 8.51926M425.812 8.51926L426.426 7.9051M426.426 7.9051L426.756 7.24373M428.74 8.84991V2M428.74 2H432.992M428.74 5.25963H431.339M428.74 8.84991H432.992M434.929 8.84991V2M434.929 2L439.511 8.84991M439.511 8.84991V2M444.377 2V8.84991M442.11 2H446.692M448.015 8.84991V2M448.015 2H450.944M450.944 2L451.889 2.33072M451.889 2.33072L452.219 2.66137M452.219 2.66137L452.55 3.32274M452.55 3.32274V3.98411M452.55 3.98411L452.219 4.59826M452.219 4.59826L451.889 4.92891M451.889 4.92891L450.944 5.25963M450.944 5.25963H448.015M450.282 5.25963L452.55 8.84991M454.865 8.84991L457.463 2M457.463 2L460.061 8.84991M455.81 6.58237H459.069M462.045 2V8.84991M462.045 8.84991H465.966M478.343 2.99209L477.682 2.33072M477.682 2.33072L476.737 2M476.737 2H475.414M475.414 2L474.422 2.33072M474.422 2.33072L473.761 2.99209M473.761 2.99209V3.65346M473.761 3.65346L474.092 4.31483M474.092 4.31483L474.422 4.59826M474.422 4.59826L475.084 4.92891M475.084 4.92891L477.068 5.59028M477.068 5.59028L477.682 5.921M477.682 5.921L478.013 6.25165M478.013 6.25165L478.343 6.91301M478.343 6.91301V7.9051M478.343 7.9051L477.682 8.51926M477.682 8.51926L476.737 8.84991M476.737 8.84991H475.414M475.414 8.84991L474.422 8.51926M474.422 8.51926L473.761 7.9051M482.595 2V8.84991M480.328 2H484.863M486.185 8.84991V2M486.185 2H490.437M486.185 5.25963H488.784M486.185 8.84991H490.437M492.374 8.84991V2M492.374 2H496.626M492.374 5.25963H495.019M492.374 8.84991H496.626M498.61 2V8.84991M498.61 8.84991H502.531M515.238 3.65346L514.908 2.99209M514.908 2.99209L514.246 2.33072M514.246 2.33072L513.632 2M513.632 2H512.309M512.309 2L511.648 2.33072M511.648 2.33072L510.987 2.99209M510.987 2.99209L510.656 3.65346M510.656 3.65346L510.325 4.59826M510.325 4.59826V6.25165M510.325 6.25165L510.656 7.24373M510.656 7.24373L510.987 7.9051M510.987 7.9051L511.648 8.51926M511.648 8.51926L512.309 8.84991M512.309 8.84991H513.632M513.632 8.84991L514.246 8.51926M514.246 8.51926L514.908 7.9051M514.908 7.9051L515.238 7.24373M517.223 8.84991L519.821 2M519.821 2L522.419 8.84991M518.167 6.58237H521.427M524.403 8.84991V2M524.403 2H527.332M527.332 2L528.324 2.33072M528.324 2.33072L528.608 2.66137M528.608 2.66137L528.938 3.32274M528.938 3.32274V3.98411M528.938 3.98411L528.608 4.59826M528.608 4.59826L528.324 4.92891M528.324 4.92891L527.332 5.25963M524.403 5.25963H527.332M527.332 5.25963L528.324 5.59028M528.324 5.59028L528.608 5.921M528.608 5.921L528.938 6.58237M528.938 6.58237V7.57438M528.938 7.57438L528.608 8.23582M528.608 8.23582L528.324 8.51926M528.324 8.51926L527.332 8.84991M527.332 8.84991H524.403M531.253 2V8.84991M531.253 8.84991H535.174M536.78 8.84991V2M536.78 2H541.032M536.78 5.25963H539.426M536.78 8.84991H541.032",
    stroke: "white",
    strokeWidth: 2.36204
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M354.184 21.4634L404.731 5.49609M404.731 5.49609H418.431",
    stroke: "white",
    strokeWidth: 2.36204
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer3);
export default __webpack_public_path__ + "static/media/Layer3.a913ef5bf87a0055ff111c0c7e5367c3.svg";
export { ForwardRef as ReactComponent };